import { useSelector } from "react-redux";
import { useMemo } from "react";
import { ENTITY_TYPE } from "../../constants";

/**
 * Hook to get facility group information and all facilities in that group
 * @params {string|null} entityID
 * @returns {Object} { facilityGroupID: string|null, facilityGroupChildren: object[] }
 */
const useFacilityGroup = (entityID) => {
  const entities = useSelector((state) => state?.orgTree?.entities ?? {});

  return useMemo(() => {
    const NOT_FOUND = { facilityGroupID: null, facilityGroupChildren: [] };

    if (!entityID || !entities) return NOT_FOUND;

    const findFacilityGroup = (id) => {
      const entity = entities[id];
      if (!entity) return null;

      if (entity.typeid === ENTITY_TYPE.FacilityGroup) {
        return entity;
      }
      if (!entity.parententityid) return null;

      return findFacilityGroup(entity.parententityid);
    };

    const facilityGroup = findFacilityGroup(entityID);
    if (!facilityGroup) return NOT_FOUND;

    const collectFacilities = groupID => {
      return Object.values(entities)
        .filter(entity => 
          entity.parententityid === groupID && 
          entity.typeid === ENTITY_TYPE.Facility
        );
    }

    return {
      facilityGroupID: facilityGroup.entityid,
      facilityGroupChildren: collectFacilities(facilityGroup.entityid),
    };
  }, [entityID]);
};

export default useFacilityGroup;
